// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__6c4ed","title":"Images45_title__3kRbY","images":"Images45_images__3r7RY"};